import { Button } from "@/components/ui/button";

export function PageSkeleton() {
  return (
    <div className="animate-pulse space-y-4" data-testid="page-loading" aria-busy="true" aria-label="Loading">
      <div className="h-12 w-2/3 rounded-xl bg-[var(--cw-surface-tertiary)]" />
      <div className="h-4 w-40 rounded bg-[var(--cw-surface-tertiary)]" />
      <div className="space-y-3 pt-8">
        {[0, 1, 2, 3].map((i) => <div key={i} className="h-4 rounded bg-[var(--cw-surface-tertiary)]" />)}
        <div className="h-4 w-1/2 rounded bg-[var(--cw-surface-tertiary)]" />
      </div>
    </div>
  );
}

export function PageError({ message, onRetry }) {
  return (
    <div className="rounded-[20px] border border-border bg-white p-8" role="alert" data-testid="page-error">
      <p className="font-medium">We couldn’t load this page.</p>
      <p className="cw-soft mt-1 text-sm">{message}</p>
      {onRetry && (
        <Button variant="outline" className="mt-6 rounded-full" onClick={onRetry} data-testid="page-error-retry-button">Try again</Button>
      )}
    </div>
  );
}
